import apiClient from "./apiClient";

const BASE = "/api/strategy-control";

/**
 * 서비스 상태 조회 (5초 polling용)
 * 연결 실패 시 에러 throw → UI DISCONNECTED 처리
 * @returns {Promise<Object>} { services: [...], active_schedule: {...}|null }
 */
export async function getServicesStatus() {
    try {
        const response = await apiClient.get(`${BASE}/services/status`);
        return response.data;
    } catch (error) {
        throw error;
    }
}

/**
 * 서비스 활성화
 * @param {string} name - 서비스명
 * @returns {Promise<Object>}
 */
export async function enableService(name) {
    try {
        const response = await apiClient.post(`${BASE}/services/${name}/enable`);
        return response.data;
    } catch (error) {
        throw error;
    }
}

/**
 * 서비스 비활성화
 * @param {string} name - 서비스명
 * @returns {Promise<Object>}
 */
export async function disableService(name) {
    try {
        const response = await apiClient.post(`${BASE}/services/${name}/disable`);
        return response.data;
    } catch (error) {
        throw error;
    }
}

/**
 * 서비스 수동 토글 (편의 래퍼)
 * @param {string} name
 * @param {boolean} enable
 * @returns {Promise<Object>}
 */
export async function toggleService(name, enable) {
    return enable ? enableService(name) : disableService(name);
}

const strategyControlApi = {
    getServicesStatus,
    enableService,
    disableService,
    toggleService,
};

export default strategyControlApi;
